import { useQuery } from '@tanstack/react-query';
import { getAllStates, getCountyByZip } from '@uplift/api';
import { BaseQueryOpts } from './baseTypes';


export const useStatesQuery = (opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'geo', 'states' ],
    queryFn: getAllStates,
    select: response => response.data,
    ...opts,
  });
};


export const useStateQuery = (stateId?: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'geo', 'states' ],
    queryFn: getAllStates,
    select: response => response.data.find(s => s.id === stateId),
    enabled: !!stateId,
    ...opts,
  });
};


export const useCountyQuery = (zip?: string, opts?: BaseQueryOpts) => {
  return useQuery([ 'geo', 'county', zip ], async () => {
    const addressCountyResponse = await getCountyByZip(zip).then(res => res.data?.map(c => c.countyName).join(', ')).catch(() => undefined);

    return addressCountyResponse;
  }, {
    enabled: !!zip,
    ...opts,
  });
};

